<template>
    <v-container fluid>
        <v-row>
            <v-container fluid>
                <v-card>
                    <v-card-text>
                        <v-row align="center" justify="center">
                            <v-col cols="12" sm="8" align="start" justify="center">
                                <v-row class="grey lighten-4" align="start" justify="center">
                                    <v-col cols="12"> <strong>FILTROS</strong></v-col>
                                    <v-col cols="12" sm="4">
                                        <v-menu
                                            ref="menu"
                                            v-model="menu"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            max-width="290px"
                                            min-width="auto"
                                        >
                                            <template #activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="fechaFiltro"
                                                    hide-details="auto"
                                                    dense
                                                    label="FILTRAR POR RANGO - MES"
                                                    prepend-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                />
                                            </template>
                                            <v-date-picker v-model="fechaFiltro" range no-title scrollable>
                                                <v-spacer />
                                                <v-btn text color="primary" @click="menu = false"> CERRAR </v-btn>
                                                <v-btn color="primary" @click="filtrarProspecto"> BUSCAR </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-divider inset vertical></v-divider>
                                    <v-col cols="6" sm="4">
                                        <v-autocomplete
                                            clearable
                                            v-model="isSelectCanal"
                                            dense
                                            hide-details="auto"
                                            outlined
                                            :items="listaCanal"
                                            item-text="canal"
                                            item-value="idCanal"
                                            label="Buscar por Canal"
                                        >
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols="6" sm="4">
                                        <v-autocomplete
                                            clearable
                                            v-model="isSelectOrigen"
                                            dense
                                            hide-details="auto"
                                            outlined
                                            :items="itemListaOrigen"
                                            item-text="origen"
                                            item-value="idOrigen"
                                            label="Buscar por Origen"
                                        >
                                            <template v-slot:item="data">
                                                <v-chip small color="secondaryTheme" class="caption px-2" dark>{{ data.item.canal }}</v-chip>
                                                &nbsp;&nbsp;<span class="caption">{{ data.item.origen }} </span>
                                            </template>
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols="6" sm="4">
                                        <v-autocomplete
                                            clearable
                                            v-model="isSelectDepartamento"
                                            dense
                                            hide-details="auto"
                                            outlined
                                            v-validate="{ required: false }"
                                            required="false"
                                            :error-messages="errors.collect('isSelectDepartamento')"
                                            data-vv-name="isSelectDepartamento"
                                            data-vv-as="departamento"
                                            :items="departamentoAssign"
                                            item-text="descripcion"
                                            item-value="idDepa"
                                            label="Buscar por Departamento"
                                        >
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols="6" sm="4">
                                        <v-autocomplete
                                            clearable
                                            v-model="isSelectProvincia"
                                            dense
                                            hide-details="auto"
                                            outlined
                                            :items="provincias"
                                            item-text="descripcion"
                                            item-value="idProv"
                                            label="Buscar por Provincia"
                                        >
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols="6" sm="4">
                                        <v-text-field
                                            dense
                                            outlined
                                            v-model="isNumeroDocumento"
                                            label="DNI DEL CLIENTE"
                                            required
                                            placeholder="Numero de Documento"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="6" sm="4">
                                        <v-text-field
                                            dense
                                            outlined
                                            v-model="isTelephone"
                                            label="BUSCAR POR TELEFONO"
                                            required
                                            placeholder="Telefono"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="6" sm="4">
                                        <v-btn small color="primary" dark @click="filtrarProspecto"> FILTRAR</v-btn>
                                    </v-col>
                                    <v-spacer></v-spacer>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-row>
                                    <v-col cols="12"> <strong>ACTIONS</strong></v-col>
                                    <v-col cols="12" align="start" justify="center">
                                        <v-btn class="mx-1" small color="green" dark @click="downloadHandle">
                                            DESCARGAR <v-icon right dark> mdi-arrow-down-box </v-icon>
                                        </v-btn>
                                        <v-btn class="mx-1" small color="green" dark @click="fnReload"> RELOAD <v-icon right dark> mdi-reload </v-icon> </v-btn>

                                        <v-btn class="mx-1" v-if="optionalRole['create']" small color="primary" dark @click="openForm(1)"> CREAR </v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-container>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-title dark>
                        <strong>PROSPECTOS</strong>
                        <v-spacer />
                        <v-spacer />

                        <v-row>
                            <v-col cols="6">
                                <v-select
                                    clearable
                                    class="mx-1"
                                    :items="estadoLista"
                                    item-text="descripcion"
                                    item-value="id"
                                    label="Filtrar Por Estados"
                                    v-model="estadoSeleccionado"
                                    single-line
                                    hide-details
                                ></v-select>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field v-model="search" append-icon="mdi-magnify" label="BUSCAR" single-line hide-details />
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table
                            item-key="idProspecto"
                            flat
                            :headers="headers"
                            :items="listaProspectos"
                            :search="search"
                            :loading="loading"
                            loading-text="...Cargando"
                        >
                            <template v-slot:[`item.lastEstadoProspecto`]="{ item }">
                                <v-chip :color="colorChip(item)" dark>
                                    {{ item.lastEstadoProspecto }}
                                </v-chip>
                            </template>
                            <template v-slot:[`item.actions`]="{ item }">
                                <v-icon color="green" @click="openForm(4, item)"> mdi-eye </v-icon>
                                <v-icon color="blue" @click="openForm(2, item)"> mdi-pencil </v-icon>
                                <v-icon v-if="roles[0] == 'SUPERADMIN'" color="red" @click="openForm(3, item)"> mdi-delete </v-icon>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <Delete v-if="openDelete" :open="openDelete" :loadingBTN="loadingBTN" @handle-delete="fnHandlePut" @closeModal="closeModal" />
        <Documento v-if="openDocumento" :open="openDocumento" @handle-search="fnHandleGet" @closeModal="closeModal" />
        <Canal v-if="openCanal" :open="openCanal" @handle-search="fnHandleGet" @closeModal="closeModal" />
        <Prospecto v-if="openProspecto" :open="openProspecto" :step="step" :textButton="modalText" @closeModal="closeModal" @reload="fnReload" />
    </v-container>
</template>
<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import { exportXLSX } from '@/utils'
import { renameKeys } from '@/utils/genericUtils'
import { mixins } from '@/mixins/mixin.js'
import Delete from '@/components/modals/Delete'
import Documento from '@/components/modals/Documento'
import Prospecto from '@/components/modals/Prospecto'
import Canal from '@/components/modals/Canal'
import { format, addDays, subDays, differenceInDays } from 'date-fns'

const defaultText = 'REGISTRAR'

export default {
    $_veeValidate: {
        validator: 'new'
    },
    components: {
        Delete,
        Documento,
        Prospecto,
        Canal
    },
    mixins: [mixins],
    data() {
        return {
            fechaFiltro: [format(subDays(new Date(), 45), 'YYYY-MM-DD'), format(new Date(), 'YYYY-MM-DD')],
            isSelectDepartamento: null,
            isSelectProvincia: null,
            isSelectCanal: null,
            isSelectOrigen: null,
            isTelephone: null,
            isNumeroDocumento: null,
            numeroDocumento: null,
            itemListaOrigen: [],
            listaProspectos: [],
            menu: false,
            found: [],
            estadoSeleccionado: null,
            openCanal: false,
            openEstado: false,
            openProspecto: false,
            openDelete: false,
            openDocumento: false,
            search: '',
            singleSelect: true,
            loadingBTN: false,
            selected: null,
            modalText: defaultText,
            step: 1,
            loading: false
        }
    },
    watch: {
        openProspecto(val) {
            if (!val) {
                console.log('listen to close')
                this.EMPTY_FORM()
            }
        },

        isSelectCanal(val) {
            if (val) {
                console.log('this.isSelectCanal', val)
                this.itemListaOrigen = this.listaOrigen.filter((x) => x.idCanal == val)
            } else {
                this.itemListaOrigen = []
            }
        },
        step(val) {
            if (val == 1) {
                this.modalText = defaultText
            } else if (val == 2) {
                this.modalText = 'ACTUALIZAR'
            } else if (val == 3) {
                this.modalText = 'ELIMINAR'
            } else {
                this.modalText = 'VISUALIZAR'
            }
        },
        async isSelectDepartamento(val) {
            console.log('isSelectDepartamento --', val)
            if (val) {
                await this.handleGetProvincias({ id: val })
                if (this.step == 1) {
                    this.UPDATE_DATOS({
                        idDistrito: null
                    })
                }
            }
        },
        estadoSeleccionado(val) {
            console.log('val___', val)
            if (val) {
                this.listaProspectos = this.lista.filter((element) => element.idLastEstadoProspecto == val)
            } else {
                this.listaProspectos = this.lista
            }
        }
    },
    computed: {
        ...mapGetters('prospectos', ['lista']),
        ...mapGetters('usuarios', ['listaCanal']),
        ...mapGetters('usuarios', ['optionalRole']),
        ...mapGetters('ubigeo', ['departamentoAssign']),
        ...mapState('ubigeo', ['provincias', 'distritos']),
        ...mapState('usuarios', ['listaOrigen', 'roles', 'userLogin']),
        ...mapState('prospectos', ['datos']),
        ...mapState('utilities', ['tipoDocumento']),
        ...mapGetters({
            estadoLista: 'estados/lista'
        }),

        headers() {
            console.log('this.$vuetify.breakpoint.name ', this.$vuetify.breakpoint.name)
            const breakpoint = this.$vuetify.breakpoint.name
            const baseList = [
                { text: 'Actions', value: 'actions', sortable: false },
                { text: 'Estado', value: 'lastEstadoProspecto' },
                { text: 'Departamento', value: 'departamento' },
                { text: 'Fecha Creación', value: 'fechaCreacion' },
                { text: 'canal', value: 'canal' },
                { text: 'Nombres', value: 'nombreCompletos' }
            ]
            if (breakpoint == 'xs' || breakpoint == 'sm') {
                return baseList
            } else {
                return [
                    { text: 'Actions', value: 'actions', sortable: false },
                    { text: 'Estado', value: 'lastEstadoProspecto' },
                    { text: 'Departamento', value: 'departamento' },
                    { text: 'Provincia', value: 'provincia' },
                    { text: 'Usuario Creación', value: 'nombreUsuarioCreacion' },
                    { text: 'Usuario Asignado', value: 'nombreUsuarioModificacion' },
                    { text: 'Fecha Creación', value: 'fechaCreacion' },
                    { text: 'canal', value: 'canal' },
                    { text: 'origen', value: 'origen' },
                    { text: 'Modelo', value: 'modelo' },
                    { text: 'Nro Documento', value: 'numeroDocumento' },
                    { text: 'Nombres', value: 'nombreCompletos' },
                    { text: 'telefono', value: 'telefono' },
                    { text: 'correo', value: 'correo' }
                ]
            }
        }
    },
    methods: {
        ...mapMutations({
            RESET_FORM: 'prospectos/RESET_FORM',
            UPDATE_DATOS: 'prospectos/UPDATE_DATOS',
            OPEN_MODAL: 'mainUI/OPEN_MODAL',
            OPEN_BAR: 'mainUI/OPEN_BAR'
        }),
        ...mapActions({
            handleGet: 'prospectos/obtenerLista',
            handleGetEstados: 'estados/obtenerLista',
            handlePost: 'prospectos/registrarProspecto',
            handlePut: 'prospectos/actualizarProspecto',
            handleGetDepartamentos: 'ubigeo/obtenerListaDepartamentos',
            handleGetProvincias: 'ubigeo/obtenerListaPronvincias',
            handleGetDistritos: 'ubigeo/obtenerListaDistritos'
        }),
        EMPTY_FORM() {
            this.openProspecto = false
            this.loading = false
            this.loadingBTN = false
            this.openCanal = false
            this.openEstado = false
            this.menu = false
            this.selected = null
            this.openDelete = false
            this.openDocumento = false
            this.OPEN_MODAL({ state: false })
            this.step = 1
            this.RESET_FORM()
        },
        colorChip(item) {
            if (item.lastEstadoProspecto === 'NUEVO' || item.lastEstadoProspecto === 'REINGRESO') {
                return 'green'
            } else if (item.lastEstadoProspecto === 'CITA') {
                return 'light-blue darken-2'
            } else {
                return 'orange'
            }
        },
        async openForm(tipo, item) {
            this.step = tipo
            let status = false
            this.selected = item

            if (tipo == 1) {
                this.RESET_FORM()
                status = true
            } else if (tipo == 2 || tipo == 4) {
                if (!item) {
                    this.OPEN_BAR({ state: true, text: 'No hay selección', color: 'red' })
                } else {
                    status = true
                    console.log('item ', item)
                    this.UPDATE_DATOS({
                        idDepartamento: item.idDistritoEnvio
                    })
                    this.UPDATE_DATOS(item)
                }
            } else if (tipo == 3) {
                if (!item) {
                    this.OPEN_BAR({ state: true, text: 'No hay selección', color: 'red' })
                } else {
                    this.openDelete = true
                }
            }
            this.openProspecto = status
        },

        async fnHandlePut() {
            console.log('fnHandlePut ')
            this.loadingBTN = true
            const item = this.selected
            if (this.step == 3) {
                item.activo = 0
            }
            await this.handlePut(item)
            await this.fnHandleGet({ idDepartamento: this.isSelectDepartamento })
            this.EMPTY_FORM()
        },
        async filtrarProspecto() {
            this.$validator.validateAll().then(async (result) => {
                if (result) {
                    console.log('result ', result)
                    await this.fnHandleGet({
                        idCanal: this.isSelectCanal,
                        idOrigen: this.isSelectOrigen,
                        idDepartamento: this.isSelectDepartamento,
                        idProvincia: this.isSelectProvincia,
                        telephone: this.isTelephone,
                        numeroDocumento: this.isNumeroDocumento
                    })
                    this.menu = false
                    this.estadoSeleccionado = 0
                }
            })
        },
        async fnHandleGet(payload) {
            console.log("fnHandleGet", payload)
            const {
                numeroDocumento = null,
                telephone = null,
                idCanal = null,
                idOrigen = null,
                usuario = null,
                idDepartamento = null,
                idProvincia = null
            } = payload
            console.log('numeroDocumento ', numeroDocumento)
            this.loading = true
            await this.handleGet({ fechaFiltro: this.fechaFiltro, numeroDocumento, telephone, idCanal, idOrigen, idDepartamento, idProvincia })
            console.log('______', this.lista)
            this.listaProspectos = this.lista
            this.loading = false
            // this.EMPTY_FORM()
        },

        downloadHandle() {
            this.loading = true
            const renameHeader = {
                idProspecto: 'id_Prospecto',
                lastEstadoProspecto: 'Ultimo_Estado_Prospecto',
                fechaISOCreacion: 'fecha_Creacion',
                horaCreacion: 'hora_Creacion',
                usuarioCreacion: 'usuario_Creacion',
                usuarioModificacion: 'usuario_Modificacion',
                descripcion: 'descripcion',
                origen: 'origen',
                canal: 'canal',
                modelo: 'modelo',
                modeloOrigen: 'modeloOrigen',
                marcaOrigen: 'marcaOrigen',
                departamento: 'departamento',
                provincia: 'provincia',
                distrito: 'distrito',
                direccionCompletaEnvio: 'direccion',
                tipoDocumento: 'tipo_Documento',
                numeroDocumento: 'numero_Documento',
                nombreCompletos: 'nombre_Completos',
                telefono: 'telefono',
                correo: 'correo',
                tipoPago: 'tipo_Pago',
                metodoEnvio: 'metodo_Envio'
            }

            const filename = `REPORT_PROSPECTOS_${Date.now()}`
            const renameArray = renameKeys(this.lista, renameHeader)
            console.log('renameArray', renameArray)
            const headers = Object.keys(renameArray[0])
            exportXLSX({ headers, campos: headers, arrayData: renameArray }, { filename })
            this.loading = false
        },
        async closeModal(nombreModal) {
            this.EMPTY_FORM()
            this[nombreModal] = false
        },
        async fnReload() {
            console.log('reload')
            await this.fnHandleGet({ idDepartamento: this.isSelectDepartamento })
            this.estadoSeleccionado = 0
        },
        getInfoSlash(value) {
            console.log('value ', value)
            if (value) {
                return value.split('|')
            } else {
                return ['', '', '', '']
            }
        }
    },
    async created() {
        const oRoles = this.optionalRole
        if (this.userLogin.idRole === 9) {
            return this.$router.push('/reclamaciones')
        }

        let idDepas = [null]
        if (!oRoles.allLocation) {
            idDepas = oRoles.idDepartamento
            //this.isSelectDepartamento = idDepas[0]
        }
        await this.fnHandleGet({})
        await this.handleGetDepartamentos()
        await this.handleGetEstados({ status: false })
        this.estadoSeleccionado = 0
    },
    mounted() {
        let iteration = 0
        window.setInterval(async () => {
            iteration = iteration + 1
            await this.filtrarProspecto()
        }, 1000 * 60 * 10)
    }
}
</script>
